import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "asRooms" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "asRooms_status -hidden" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "asRooms_avatar -support" }, null, -1)
const _hoisted_4 = { class: "asRooms_message" }
const _hoisted_5 = { class: "asRooms_author" }
const _hoisted_6 = { class: "asRooms_text" }
const _hoisted_7 = ["onClick", "data-cy"]
const _hoisted_8 = { class: "asRooms_message" }
const _hoisted_9 = { class: "asRooms_author" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_avatar = _resolveComponent("as-avatar")!
  const _component_as_tech_question = _resolveComponent("as-tech-question")!
  const _component_as_modal = _resolveComponent("as-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.techSupport && _ctx.showSupport)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToSupport && _ctx.goToSupport(...args))),
          class: "asRooms_room",
          "data-cy": "chatRoom_support"
        }, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('techSupport')), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('questionTechSupport')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        onClick: ($event: any) => (_ctx.goToChat({ to: { name: 'chat', params: { chatId: room.id } }, streamId: room.streamId })),
        class: _normalizeClass(["asRooms_room", { '-active': room.id === _ctx.currentId }]),
        "data-cy": room.id === _ctx.currentId ? 'chatRoomActive' : 'chatRoom'
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["asRooms_status", { '-update': _ctx.hasUnviewedMessages(room.streamId) }])
        }, null, 2),
        _createElementVNode("div", {
          class: "asRooms_avatar",
          style: _normalizeStyle({ backgroundImage: `url(${room.avatar})` })
        }, [
          (room.avatar)
            ? (_openBlock(), _createBlock(_component_as_avatar, {
                key: 0,
                src: room.avatar,
                width: 54,
                height: 54
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(room.author), 1),
          (_ctx.getTimeSubtext(room))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "asRooms_time",
                innerHTML: _ctx.getTimeSubtext(room)
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ], 10, _hoisted_7))
    }), 128)),
    _createVNode(_component_as_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modal) = $event)),
      btnClose: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_tech_question, {
          onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = false))
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}